// DEBE ir primero: inicializa Sentry antes que el resto de la app para capturar
// errores desde el arranque.
import Sentry from './sentry';
import React from 'react';
import '@ant-design/v5-patch-for-react-19';
// import './assets/boxicons-2.0.7/css/boxicons.min.css';
import { Button, notification, Result } from 'antd';
import { createRoot } from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import App from './App';
import whitTheme from 'assets/theme/default';
import { installAxiosInterceptors } from 'api/axiosInterceptors';

installAxiosInterceptors();

// Fallback cuando un error de render rompe la app (pantalla en blanco). El error
// ya quedó reportado a Sentry por el ErrorBoundary; al usuario le mostramos un
// aviso neutral con opción de recargar.
const errorFallback = (
  <Result
    status="error"
    title="Ocurrió un problema"
    subTitle="La aplicación encontró un error inesperado. Recargá la página para continuar."
    extra={
      <Button type="primary" onClick={() => window.location.reload()}>
        Recargar
      </Button>
    }
  />
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={errorFallback}>{whitTheme(<App />)}</Sentry.ErrorBoundary>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.active.postMessage('version_updated');
  });
}

// Aviso de actualización: cuando hay una versión nueva del SW, mostrar un toast
// con botón "Recargar". Al hacer clic, se le manda SKIP_WAITING al SW en espera;
// cuando toma control, serviceWorkerRegistration recarga la página una vez.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waiting = registration.waiting;
    if (!waiting) return;
    const key = 'sw-update-available';
    notification.info({
      key,
      message: 'Nueva versión disponible',
      description: 'Hay una actualización de la aplicación. Recargá para usar la última versión.',
      duration: 0,
      placement: 'bottomRight',
      btn: (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            waiting.postMessage({ type: 'SKIP_WAITING' });
            notification.destroy(key);
          }}
        >
          Recargar
        </Button>
      ),
    });
  },
});

reportWebVitals();
